import { RegularButton, Modal } from 'fronton-react'
import { FC } from 'react'
import './modalClasses.scss'

export interface DeleteConfirmModalProps {
    open: boolean
    onClose: () => void
    onDelete: () => void
}

export const DeleteConfirmModal: FC<DeleteConfirmModalProps> = ({ open, onClose, onDelete }) => {
    return (
        <Modal
            size="s"
            show={open}
            className="add-calendar-modal"
            closeButton={false}
            onClose={onClose}
            overlayType="medium"
        >
            <div className="modal-content">
                <div className="modal-content-body">Удалить календарь?</div>
                <div className="modal-content-actions">
                    <RegularButton
                        key="submit"
                        size="s"
                        variant="primary"
                        className="modal-content-btn"
                        onClick={onDelete}
                    >
                        Да
                    </RegularButton>
                    <RegularButton
                        key="submit"
                        size="s"
                        variant="primary"
                        className="modal-content-btn"
                        onClick={onClose}
                    >
                        Нет
                    </RegularButton>
                </div>
            </div>
        </Modal>
    )
}
